import { useFoldersStore } from '../store';
export var useInitializeFolders = function (shouldInitialize, force) {
    var store = useFoldersStore();
    if (shouldInitialize) {
        store.initialize(force);
    }
};
export var useFolders = function () {
    return useFoldersStore(function (store) { return store.foldersData; });
};
//# sourceMappingURL=useFolders.js.map